<template>
  <div id="wrapper">
    <Nav :message="message" />
    <VendorList :vendors="vendors" />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import VendorList from '@/components/finance/VendorList.vue'

export default {
  name: 'vendor',
  props: ['message'],
  components: {
    Nav,
    VendorList
  },
  data: function() {
    return {
      vendors: []
    }
  },
  created: function() {
    
  }
}
</script>